import { useNavigate } from 'react-router-dom';
import styles from './LandingBase.module.css';
import Logo from '../../images/Logo';
import Switch from '../../componentes/switch/Switch';

type Props = {
  onLogin: () => void;
  onCreateAccount: () => void;
  esconder?: boolean;
  atualizar?: boolean;
  onAtualizar: (value: boolean) => void;
};

const scrollTo = (id: string) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

const Header = ({ onLogin, onCreateAccount, esconder = false, atualizar = false, onAtualizar }: Props) => {
  const navigate = useNavigate();

  const handleAparencia = (value: string) => {
    const root = document.documentElement;
    root.setAttribute('data-theme', value);
    localStorage.setItem('tema', value);
    onAtualizar(!atualizar);
  };

  const tema = localStorage.getItem('tema');

  return (
    <header className={styles.nav} id="principal">
      <div className={styles.navInner}>
        <div className={styles.brand} onClick={() => navigate('/')}>
          <Logo className={styles.brandIcon} />
          <span>Finant</span>
        </div>

        {!esconder && (
          <nav className={styles.navLinks}>
            <span className={styles.navLink} onClick={() => scrollTo('funcionalidades')}>
              Funcionalidades
            </span>
            <span className={styles.navLink} onClick={() => scrollTo('como')}>
              Como funciona
            </span>
            <span className={styles.navLink} onClick={() => scrollTo('perguntas')}>
              Perguntas
            </span>
          </nav>
        )}

        {!esconder && (
          <div className={styles.navActions}>
            <span className={`${styles.themeIcon} material-symbols-rounded`}>{tema === 'dark' ? 'dark_mode' : 'light_mode'}</span>
            <Switch checked={tema === 'dark'} onChange={(value) => handleAparencia(value ? 'dark' : 'light')} />
            <button className={styles.btnGhost} onClick={onLogin}>
              Entrar
            </button>
            <button className={styles.btnPrimary} onClick={onCreateAccount}>
              Começar grátis
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
